import { render, staticRenderFns } from "./Radios.vue?vue&type=template&id=2f2488d4&scoped=true"
import script from "./Radios.vue?vue&type=script&lang=ts"
export * from "./Radios.vue?vue&type=script&lang=ts"
import style0 from "./Radios.vue?vue&type=style&index=0&id=2f2488d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2488d4",
  null
  
)

export default component.exports